import CalendarContainer from "./CalendarContainer"

export default function CalendarScreen() {
    return <CalendarContainer />
}